import "./TeamChannel.scss";

import { Avatar, Text } from "@fluentui/react-northstar";
import { app } from "@microsoft/teams-js";
import { channelDeepLink } from "@teams/cards";
import { TeamsApplicationTypes } from "@teams/types";
import React from "react";

import { startTaskErrorMessage } from "../utils/startTaskErrorMessage";

export type TeamChannelParams = {
  applicationType: TeamsApplicationTypes;
  channelName?: string;
  channelId?: string;
  teamName?: string;
};

type TeamChannelProps = {
  channel: TeamChannelParams;
  postfix?: string;
};

export const TeamChannel: React.FC<TeamChannelProps> = ({ channel, postfix }) => {
  if (!channel.channelName || !channel.channelId) {
    return null;
  }

  const linkAddress = channelDeepLink({
    channelId: channel.channelId,
    channelName: channel.channelName,
  });

  const onClick = (event: React.MouseEvent) => {
    if (!channel.channelId || !channel.channelName) {
      startTaskErrorMessage(
        "Unable to navigate to channel, missing channel information",
        channel.applicationType
      );
      return;
    }

    app.openLink(linkAddress);

    event.preventDefault();
  };
  return (
    <a className="team-channel__container" onClick={onClick} href={linkAddress}>
      <Avatar
        className="team-channel__avatar"
        size="smallest"
        name={channel.teamName || channel.channelName}
      />
      {channel.teamName && (
        <>
          <Text className="team-channel__label" size="small" content={channel.teamName} />
          <Text className="team-channel__separator" size="small" content=">" />
        </>
      )}
      <Text className="team-channel__label" size="small" content={channel.channelName} />

      {postfix && <Text className="team-channel__label" size="small" content={` - ${postfix}`} />}
    </a>
  );
};
